import { render } from "./pendingGeneral.vue?vue&type=template&id=12e26c6e"
import script from "./pendingGeneral.vue?vue&type=script&lang=js"
export * from "./pendingGeneral.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__